import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Result} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';
import {initReducerContext} from '@someok/simple-reducer-store';
import {useUnmount} from 'react-use';

import {isAzureAuth} from '@/app/AuthUtils';
import {getAzureUserApp, getUserApp} from '@/api/apps';
import appActions from './actions';
import {useCurrentUserAppsProfile} from '@/page/HomePage/useHomeService';
import {useHeaderSubTitleStore} from 'app/wrapper/AppLayout/context/HeaderSubTitle';

const initialState = {
    appId: null,
    userId: null,

    app: {},

    isMgr: false,
    isUser: false,
};

const [useAppStore, AppStoreProvider, AppContext] = initReducerContext(initialState, appActions);

export {useAppStore, AppStoreProvider, AppContext};

export default function AppPageWrapper({children}) {
    // console.log('authStore......', authStore);
    const {currentUserId, enableReadApps} = useCurrentUserAppsProfile();
    const [, dispatchSubTitle] = useHeaderSubTitleStore();

    const [loading, setLoading] = useState(true);
    const [existApp, setExistApp] = useState(false);
    const {appId} = useParams();
    const navigate = useNavigate();
    const [, dispatch] = useAppStore();

    useUnmount(() => {
        // console.log('useUnmount app ' + appId);
        dispatchSubTitle('clearSubTitle');
    });

    useEffect(() => {
        if (!currentUserId || !enableReadApps) {
            return;
        }

        const promise = isAzureAuth
            ? getAzureUserApp(currentUserId, appId)
            : getUserApp(currentUserId, appId);
        promise.then(json => {
            console.log(json);
            if (
                !json ||
                !json.data ||
                !json.data.app ||
                !json.data.roleType ||
                !['app_mgr', 'app_user'].includes(json.data.roleType)
            ) {
                setLoading(false);
                setExistApp(false);
                return;
            }

            const {data} = json;
            // console.log('data.........', data);
            dispatch(['initApp', data]);
            dispatchSubTitle([
                'updateSubTitle',
                {
                    subTitle: data?.app?.name,
                    iconUrl: data?.app?.squareLogoUrl,
                },
            ]);

            setLoading(false);
            setExistApp(true);
        });
    }, [appId, currentUserId, dispatch, enableReadApps]);

    if (loading) {
        return null;
    }

    if (existApp) {
        return children;
    }

    return (
        <Result
            status="404"
            title="404"
            subTitle="应用不存在或无权访问此应用"
            extra={
                <Button type="primary" onClick={() => navigate('/')}>
                    返回首页
                </Button>
            }
        />
    );
}

AppPageWrapper.propTypes = {
    children: PropTypes.node,
};
